import * as React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Container, Grid2, Typography, Box, Toolbar } from '@mui/material'
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { useDispatch, useSelector } from 'react-redux';
import dayjs from 'dayjs';
import ModernNavbar from '../setup/ModernNavbar'
import Loading from '../../BuiltInComponent/Loading';
import TableDataWithPagination from '../../BuiltInComponent/TableWithPagination';
import HeadingText from '../../BuiltInComponent/HeadingTest';
import Footer from '../setup/Footer';
import { getDailyAttendance } from '../../features/PayrollManagement/attendanceSlice';
import IndividualAttendanceReportPDF from '../PayrollReports/IndividualAttendanceReportPDF';
export default function IndividualAttendanceSheet() {

    const location = useLocation()
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const { dateWiseAtt, isLoading } = useSelector(state => state.att)

    const targetDate = React.useMemo(() => {
        return location.state?.targetDate ? dayjs(location.state.targetDate) : dayjs()
    }, [location.state?.targetDate])

    React.useEffect(() => {
        dispatch(getDailyAttendance({
            procOrder: 'Get Employee Wise',
            targetDate: targetDate.format('YYYY-MM-DD'),
            empID: location.state?.empID || null
        }))
    }, [location.state?.empID, targetDate, dispatch])


    const tableColumns = [
        { fieldName: 'empID', cName: 'Emp Pic', textAlign: 'left', width: 80, dType: 'img', status: 'en' },
        { fieldName: 'empImage', cName: 'Emp Pic', textAlign: 'center', width: 80, dType: 'img', status: 'en' },
        { fieldName: 'punch_date', cName: 'Att Date', textAlign: 'center', width: '5%', dType: 'date', status: 'en' },
        { fieldName: 'day_name', cName: 'Day', textAlign: 'center', width: '5%', dType: 'string', status: 'en' },
        { fieldName: 'attendance_statusMark', cName: 'Status', textAlign: 'center', width: '5%', dType: 'string', status: 'en' },
        { fieldName: 'time_in', cName: 'Time In', textAlign: 'right', width: 80, dType: 'string', status: 'en' },
        { fieldName: 'time_out', cName: 'Time Out', textAlign: 'right', width: 80, dType: 'string', status: 'en' },
        { fieldName: 'late_in_status', cName: 'Late Status', textAlign: 'center', width: 80, dType: 'string', status: 'en' },
        { fieldName: 'early_out_status', cName: 'Early Gone', textAlign: 'center', width: 80, dType: 'string', status: 'en' },
        { fieldName: 'formatted_time_inTime', cName: 'In Time Short Excess', textAlign: 'right', width: 80, dType: 'string', status: 'en' },
        { fieldName: 'formatted_time_outTime', cName: 'Out Time Short Excess', textAlign: 'right', width: 80, dType: 'string', status: 'en' },
        { fieldName: 'formatted_time_adjustments', cName: 'Adjustments', textAlign: 'right', width: 80, dType: 'string', status: 'en' },
        { fieldName: 'edit', cName: 'Edit', textAlign: 'center', width: '20%', status: 'dis' },
        { fieldName: 'print', cName: 'Print', textAlign: 'center', width: '20%', status: 'dis' },
        { fieldName: 'print', cName: 'Print', textAlign: 'center', width: 500, status: 'dis', buttonText: `Individual` },
    ]

    const onEditClick = (id) => {
        console.log(id)
    }

    const onPrintClick = (empID) => {
        navigate('/IndividualAttSheet', { state: { empID: empID } })
    }

    return (
        <>
            <ModernNavbar />
            <Toolbar />
            <Container>
                <Grid2 container spacing={2} alignItems="center" sx={{ marginTop: 2, marginBottom: 2 }}>
                    <Grid2 size={2}></Grid2>
                    <Grid2 size={8}>
                        <HeadingText text={`Individual Attendance Sheet`} />
                    </Grid2>
                    <Grid2 size={2}></Grid2>
                    <Grid2 size={0.5}>
                        <KeyboardBackspaceIcon
                            sx={{
                                fontSize: 30, marginLeft: -1, color: 'white', cursor: 'pointer',
                                backgroundColor: '#1E90FF', padding: 1, borderRadius: 50
                            }}
                            onClick={() => { navigate('/CurrDayAtt') }} />
                    </Grid2>
                    <Grid2 size={9.5}></Grid2>
                    <Grid2 size={2}>
                        <Box display="flex" alignItems="center" justifyContent="flex-end" gap={1}>
                            {isLoading ? <Loading /> : <IndividualAttendanceReportPDF
                                data={dateWiseAtt && dateWiseAtt}
                                title={`${dateWiseAtt[0]?.empName || ''}`}
                                company="Maltex Exports"
                                fileName={`Attendance Report For ${dateWiseAtt[0]?.empName || ''}`}
                                reportDate={dayjs(new Date()).format('MMM-YYYY')}
                                label="Print Report" />
                            }
                        </Box>
                    </Grid2>
                    {dateWiseAtt && dateWiseAtt.length > 0 ?
                        <>
                            <Grid2 size={0.7}>
                                <img
                                    src={dateWiseAtt[0].empImage !== null ? `${global.SET_API_URL}/employeesImages/${dateWiseAtt[0].empImage}` : `${global.SET_API_URL}/images/1759242661144-maltexLogo.png`}
                                    alt={'notFound'}
                                    style={{ width: '50px', height: '50px', borderRadius: '50%' }}
                                />
                            </Grid2>
                            <Grid2 size={3.5}><Typography variant="h6" component="div" style={{ color: 'grey' }}>Emp Name : {dateWiseAtt[0].empName}</Typography></Grid2>
                            <Grid2 size={3}><Typography variant="h6" component="div" style={{ color: 'grey' }}>Unit : {dateWiseAtt[0].unitDescription}</Typography></Grid2>
                            <Grid2 size={3}><Typography variant="h6" component="div" style={{ color: 'grey' }}>Dept : {dateWiseAtt[0].deptName}</Typography></Grid2>
                            <Grid2 size={1.8}><Typography variant="h6" component="div" style={{ color: 'grey' }}>Shift : {dateWiseAtt[0].shiftName}</Typography></Grid2>
                        </> : <></>
                    }
                </Grid2>
                {
                    isLoading ?
                        <>
                            <Loading />
                        </>
                        :
                        dateWiseAtt.length > 0 ?
                            <TableDataWithPagination tableColumns={tableColumns} tableData={dateWiseAtt && dateWiseAtt}
                                onEditClick={onEditClick} onButtonClick={onPrintClick} perPage={50} />
                            : <><HeadingText text="Data Not Found!..." /></>
                }

            </Container>
            <Footer />
        </>
    )
}
